export const userColumns = [
  "First Name*",
  "Last Name*",
  "Username*",
  "Email*",
  "Mobile*",
  "Employee ID*",
  "Manager Email",
  "Group Name",
];
